/* eslint-disable react/no-array-index-key */
import React from 'react';
import I18n from 'i18n-js';
import { SectionTitle } from 'components';

import styles from './datadis-flujo.module.scss'; // ajusta si lo mueves

interface DatadisOrSignaturitProps {
  iSDatdis: boolean;
}

const DatadisOrSignaturit = ({ iSDatdis }: DatadisOrSignaturitProps) => (
  <>
    <div>
      <SectionTitle text="" className={styles.SectionTarfa} />
      <div className={styles.containerDatosConsumo}>
        {iSDatdis ? I18n.t('procesadoPorDatadis') : I18n.t('procesadoPorSignaturit')}
      </div>
    </div>
  </>
);

export default DatadisOrSignaturit;
